import { goTo } from "./Shared";
import { Instagram, Linkedin, Facebook } from "lucide-react";
import { useLang } from "../../i18n";

const LINK_CLASS = "font-nav text-[11px] font-semibold uppercase tracking-[0.2em] text-[#8E85AC] transition-colors hover:text-[#9B7AE8]";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-[#9B7AE8]/15 bg-white px-5 pb-10 pt-20 sm:px-8" data-testid="footer-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <img src="/assets/logo.png" alt="Shake & Shake" className="h-12 w-auto" data-testid="footer-logo" />
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-links">
            {[
              [t.nav.nedir, "#nedir"],
              [t.nav.receteler, "#receteler"],
              [t.nav.donanim, "#donanim"],
              [t.nav.neden, "#neden"],
              [t.nav.iletisim, "#talep"],
            ].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-link-${href.slice(1)}`}
                onClick={() => goTo(href)}
                className={LINK_CLASS}
              >
                {label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-6 border-t border-[#9B7AE8]/10 pt-8 lg:flex-row lg:items-center lg:justify-between">
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-legal-links">
            <a href="/sirket-bilgileri" data-testid="footer-link-sirket-bilgileri" className={LINK_CLASS}>
              {t.footer.company}
            </a>
            <a href="/kisisel-verilerin-korunmasi" data-testid="footer-link-kvkk" className={LINK_CLASS}>
              {t.footer.privacy}
            </a>
          </nav>
          <nav className="flex items-center gap-4" data-testid="footer-social-links">
            <a
              href="https://www.instagram.com/shakeand.shake/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-link-instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#9B7AE8]/25 text-[#8E85AC] transition-all duration-300 hover:border-[#9B7AE8] hover:text-[#9B7AE8]"
            >
              <Instagram size={16} strokeWidth={2} />
            </a>
            <a
              href="#"
              aria-label="LinkedIn"
              data-testid="footer-link-linkedin"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#9B7AE8]/25 text-[#8E85AC] transition-all duration-300 hover:border-[#9B7AE8] hover:text-[#9B7AE8]"
            >
              <Linkedin size={16} strokeWidth={2} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              data-testid="footer-link-facebook"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#9B7AE8]/25 text-[#8E85AC] transition-all duration-300 hover:border-[#9B7AE8] hover:text-[#9B7AE8]"
            >
              <Facebook size={16} strokeWidth={2} />
            </a>
          </nav>
        </div>

        <div className="mt-10 border-t border-[#9B7AE8]/10 pt-8 text-xs text-[#8E85AC]">
          <p data-testid="footer-copyright">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
